module.exports = __webpack_public_path__ + "img/xianmi900g.9844a576.jpg";